<template>
  <div class="content">
    <div class="head">
      <div class="porject-name">木棉树CT医疗在线管控系统</div>
      <div class="head-data">
        <div class="head-data-item">
          已检查总量（人次
          <div class="item-data" id="allnum">704</div>
        </div>
        <div class="head-data-item">
          当日检查量（人次）
          <div class="item-data" id="daynum">321</div>
        </div>
        <div class="head-data-item">
          剩余预约检查量（人次）
          <div class="item-data">39</div>
        </div>
      </div>
      <div class="head-right">
        <div class="right-item"  style="margin-left: 0.5vw;" @click=myclick(1)>
          <img src="../assets/wj.png" />
          {{name}}
        </div>
        <div class="right-item" @click=myclick(2) style="color:#39A8EB">
          <img src="../assets/lj.png" />
                 外观展示
        </div>
        <div class="right-item" @click=myclick(3)>
          <img src="../assets/nb.png" />
                 内部展示
        </div>
        <div class="right-date" id="right-date"></div>
      </div>
    </div>
    <div class="bottom">
      <div class="worktime">
        <div class="bottom-head">当前扫描时间</div>
        <div class="worktime-content">
          <div class="worktime-left" ref="echartsTwo"></div>
          <div class="workborder"></div>
          <div class="worktime-right">
            <div class="worktime-item">
              <div class="worktimetext-left">患者进场时间</div>
              <div class="workitem-right" id="workitem-righttime">01:36:00</div>
            </div>
            <div class="worktime-item">
              <div class="worktimetext-left">扫描开始时间</div>
              <div class="workitem-right" id="workitem-righttime">01:40:00</div>
            </div>
            <div class="worktime-item">
              <div class="worktimetext-left">预计结束时间</div>
              <div class="workitem-right" id="workitem-righttime">01:45:00</div>
            </div>
          </div>
        </div>
      </div>
      <div class="monitor">
        <div class="bottom-head">探测器温度</div>
        <div class="monitor-content">
          <div v-for="(item,index) in monitordata" :key="index" class="monitor-item">
            <div class="monitordata-parameter">{{item.parameter}}</div>
            <div class="monitordata-name">{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="pressure">
        <div class="bottom-head">球管曝光秒</div>
        <div ref="echartsOne" class="worktime-content"></div>
      </div>
      <div class="grouting">
        <div class="bottom-head">剩余影像储存空间</div>
        <div class="grouting-content">
          <div v-for="item in groutingdata" :key="item.name" class="grouting-item">
            <div class="grouting-name">{{item.name}}</div>
            <div v-for="i in (item.parameter)" class="grouting-nav"></div>
            <div v-for="z in (10-item.parameter)" class="grouting-def"></div>
          </div>
        </div>
      </div>
      <div class="mytables">
        <table border="1">
          <tr>
            <th></th>
            <th>已检查量</th>
            <th>剩余检查量</th>
            <th>已打印量</th>
            <th>剩余打印量</th>
          </tr>
          <tr v-for="item in 3" :key="item">
            <th style="color:#8b9eb6">{{item+"#"}}</th>
            <th>10</th>
            <th>5</th>
            <th>6</th>
            <th>4</th>
          </tr>
        </table>
      </div>
      
    </div>
    <div id="shaomiao"> 
      	<video id="videos" loop="loop">
				  <source src="../assets/shaomiao.mp4" type="video/mp4">
				</video>
    </div>
  </div>
</template>

<script type="text/javascript">
	 
import { EleResize } from "../esresize";

function _pie3() {
    let dataArr = [];
    for (var i = 0; i < 100; i++) {
        if (i % 2 === 0) {
            dataArr.push({
                name: (i + 1).toString(),
                value: 25,
                itemStyle: {
                    normal: {
                        color: "rgb(8,49,91)",
                        borderWidth: 0,
                        borderColor: "rgba(0,0,0,0)"
                    }
                }
            })
        } else {
            dataArr.push({
                name: (i + 1).toString(),
                value: 20,
                itemStyle: {
                    normal: {
                        color: "rgba(0,0,0,0)",
                        borderWidth: 0,
                        borderColor: "rgba(0,0,0,0)"
                    }
                }
            })
        }

    }
    return dataArr

}
export default {
  name: "app",
  data() {
    return {
      monitordata: [
        {
          name: "探测器温度-右",
          parameter: "34.85℃"
        },
        {
          name: "探测器温度-左",
          parameter: "34.75℃"
        },
        {
          name: "探测器温度-中",
          parameter: "35℃"
        },
        {
          name: "机架内环境温度",
          parameter: "31℃"
        },
        {
          name: "设备间温度",
          parameter: "31℃"
        },
        {
          name: "扫描间温度",
          parameter: "28℃"
        }
      ],
      groutingdata: [
        {
          name: "1#",
          parameter: 6
        },
        {
          name: "2#",
          parameter: 6
        },
        {
          name: "3#",
          parameter: 6
        },
        {
          name: "4#",
          parameter: 6
        },
        {
          name: "5#",
          parameter: 6
        },
        {
          name: "6#",
          parameter: 6
        }
      ],
      name:"开始扫描",
      nowclick:0,
    };
  },
  mounted() {
    this.drawLine();
    this.drawLineTwo();
    var d = new Date();
    document.getElementById("right-date").innerHTML=d.getFullYear()+"-"+d.getMonth()+"-"+d.getDate()+"&nbsp"+d.getHours()+":"+d.getMinutes();
    
//  document.getElementById("workitem-righttime").innerHTML=d.getHours()+":"+d.getMinutes()+":"+d.getSeconds();

  },
  created() {
//  this.test();

  },
  components: {},
  methods: {
    nowSize(val,initWidth=1920){
      let nowClientWidth = document.documentElement.clientWidth;
        return val * (nowClientWidth/initWidth);
    },
    drawLine() {
      
      const optionOne = {
        title: {
          text: "单位/s",
          textStyle: {
            color: "#8c9bb2",
            fontSize:this.nowSize(12),
          },
          right: 5,
          top: 5
        },
        grid: {
          borderWidth: 0,
          top: "13%",
          left: "8%",
          right: "5%",
          bottom: "17%"
        },
        xAxis: {
          type: "category",
          data: ["1#", "2#", "3#", "4#", "5#", "6#", "7#", "8#", "9#", "10#"],
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel:{
            textStyle: {
              fontSize:this.nowSize(12),
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#8c9bb2",
              width: "1"
            }
          }
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          axisLine: {
            show: true,
            lineStyle: {
              color: "#8c9bb2",
              width: "1",
             
            }
          },
          axisLabel:{
            textStyle: {
              fontSize:this.nowSize(12),
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#8c9bb2"
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: [0,0,0,0,0,0,0,0,0,0],
            type: "bar",
            barWidth: "45%",
            label: {
              show: true, //开启显示
              position: "top", //在上方显示
              textStyle: {
                //数值样式
                color: "#fff",
                fontSize: this.nowSize(12)
              }
            },
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#38a6e8" }, //柱图渐变色               //柱图渐变色
                  { offset: 1, color: "rgba(0,0,0,0)" } //柱图渐变色
                ])
              }
            }
          }
        ]
      };
      // let myChart = this.$echarts.init(this.$refs.echartsOne);
      // myChart.setOption(optionOne);
      let myChart = this.$echarts.init(this.$refs.echartsOne);
      myChart.setOption(optionOne);
      let listener = function() {
        myChart.resize();
      };
      EleResize.on(this.$refs.echartsOne, listener);
      window.setInterval(function () {
      		var num=[]
      		for(var i=0;i<10;i++){
      			num.push((Math.random()*3+0.1).toFixed(2));
      		}
      		optionOne.series[0].data=num;
	      	myChart.setOption(optionOne);      	
      },5000);      
      
    },
    drawLineTwo() {
      const option = {
        // backgroundColor: "#fff",
        title: [
          {
            text: "扫描进程",
            left: "45%",
            top: "83%",
            textAlign: "center",
            textStyle: {
              fontWeight: "normal",
              fontSize: this.nowSize(14),
              color: "#8b9eb6",
              textAlign: "center"
            }
          }
        ],

        //第一个图表
        series: [
          {
            type: "pie",
            hoverAnimation: false, //鼠标经过的特效
            radius: ["62%", "80%"],
            center: ["50%", "50%"],
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              normal: {
                position: "center"
              }
            },
            data: [
               {
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#00aeff"
                  }
                },
                label: {
                  normal: {
                    formatter: "0%",
                    position: "center",
                    show: true,
                    textStyle: {
                      fontSize: this.nowSize(17),
                      fontWeight: "normal",
                      color: "#00aeff"
                    }
                  }
                }
              },
              {
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#08315b"
                  }
                }
              }
            ]
          },
          {
            type: 'pie',
            zlevel: 6,
            silent: true,
            radius: ['93%', '90%'],
            label: {
                normal: {
                    show: false
                },
            },
            labelLine: {
                normal: {
                    show: false
                }
            },
            data: _pie3()
        },
        ]
      };
      let myChart = this.$echarts.init(this.$refs.echartsTwo);
      myChart.setOption(option);
      let listener = function() {
        myChart.resize();
      };
      EleResize.on(this.$refs.echartsTwo, listener);
      var laoding=1;
      //数据更新
      window.setInterval(function () {
      	if(laoding <= 100){
      		option.series[0].data[0].value=laoding;
	      	option.series[0].data[0].label.normal.formatter = laoding + "%";
	      	option.series[0].data[1].value=100-laoding;
	      	myChart.setOption(option);
	      	laoding++;
      	}else{
      		laoding=0;
      		option.series[0].data[0].value=laoding;
	      	option.series[0].data[0].label.normal.formatter = laoding + "%";
	      	option.series[0].data[1].value=100-laoding;
	      	myChart.setOption(option);	  
	      	document.getElementById("allnum").innerHTML = Number(document.getElementById("allnum").innerHTML)+1;
	      	document.getElementById("daynum").innerHTML = Number(document.getElementById("daynum").innerHTML)+1;
      	}
      	
      },2000);
    },
//  test() {
//    // this.$axios.get("http://118.123.247.236:1681/evr/PreparationController/getPreparationbytachesonid/",{"tacheson_id":"5-1"}).then(res => {
//    //   console.log(res.data);
//    // });
//  },
    myclick(num){
    	for(var i=0;i<3;i++){
      		document.getElementsByClassName("right-item")[i].style.color="#a6bcdb";
      	}
      if(num == 1){     	
      	document.getElementsByClassName("right-item")[0].style.color="#39A8EB";
        document.getElementById("shaomiao").style.display="block";
        document.getElementById("videos").play();
//      this.name = "拼装"
//      this.nowclick = 1; 
      }else if(num == 2){
      	document.getElementsByClassName("right-item")[1].style.color="#39A8EB";
      	document.getElementById("shaomiao").style.display="none";
      	document.getElementById("videos").pause();
//      document.getElementById("iframe").contentWindow.assemble();
//      this.name = "待机"
//      this.nowclick = 2
      }else if(num== 3){
      	document.getElementsByClassName("right-item")[2].style.color="#39A8EB";
      	document.getElementById("shaomiao").style.display="none";
      	document.getElementById("videos").pause();
//      document.getElementById("iframe").contentWindow.standby();
//      this.name = "掘进"
//      this.nowclick = 0;
      }
      document.getElementById("iframe").contentWindow.MMAPI.prominentStyle(num);
      console.log("点击事件")
     
    }
  }
};
	
</script>

<style scoped>
	#shaomiao{
		  position: absolute;
		  width: 14vw;
      height: 12vw;
	    left: 24%;
	    top: 12%;
	    background-image: url("../assets/videobg.png");
	    background-repeat: no-repeat;
	    background-size: 100% 100%;
	    display: none;
	   /*background-color: red;*/
	}
	video{
    margin-left: 6%;
    margin-top: 2%;
    width: 80%;
    height: 100%;
	}
/* .left {
  width: 0.5vw;
  height: 95%;
  position: absolute;
  left: 0.5%;
  top: 2.5vh;
  background: url("../assets/zt2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.top {
  width: 99%;
  height: 1vh;
  position: absolute;
  left: 0.5%;
  top: 2.5vh;
  background: url("../assets/zt1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.bottomOne {
  width: 99%;
  height: 1vh;
  position: absolute;
  bottom: 2.5vh;
  background: url("../assets/zt1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.right {
  width: 0.5vw;
  height: 95%;
  position: absolute;
  right: 0.5%;
  top: 2.5vh;
  background: url("../assets/zt2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  transform:rotateY(180deg)
} */
.content {
  width: 100%;
  height: 100%;
  /* position: absolute; */
  /* left: 0.5%; */
  /* top: 1vh; */
  /* background: url("../assets/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%; */
}
.head {
  position: absolute;
  top: 3vh;
  left: 2%;
  display: flex;
  color: #fff;
  width: 98%;
  height: 4vh;
  z-index: 1;
}

/* .iframe {
  width: 97.5%;
  height: 98%;
  position: absolute;
  top: 1vh;
  left: 1.2%;
  border-radius: 30px;
} */

.porject-name {
  color: #cadef2;
    font-family: pmzd;
    font-size: 1.6vw;
    width: 25%;
  letter-spacing: 0.4vw;
}
.porject-name:after{
  content:"";
  background: url("../assets/titlebg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 23.5%;
  line-height: 4vh;
  height: 1vh;
  position: absolute;
  left: 0;
  top: 4vh;
}
.head-data {
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-data-item {
  font-size: 0.7vw;
  color: #bbc8d6;
  margin-top: 0.7vw;
  /* background: url("../assets/item.png");
  background-repeat: no-repeat;
  background-size: 100% 100%; */
  margin-right: 0.5vw;
  display: flex;
  padding: 0.5vh 0;
  justify-content: center;
  align-items: center;
}
.item-data {
  color: #bbc8d6;
  margin-left: 0.5vw;
  width: 5vw;
  font-size: 0.8vw;
  text-align: center;
  background: url("../assets/textbg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.head-right {
  font-size: 0.7vw;
	display: flex;
	height: 4vh;
	justify-content: center;
	align-items: center;
	width: 22%;
	position: absolute;
  right: 20px;
  background: url(../assets/headright.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.right-border {
  background: url("../assets/border-right.png");
  width: 2px;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.right-item {
  color: #a6bcdb;
  display: flex;
  height: 53%;
  justify-content: center;
  align-items: center;
  width: 22%;
  border-right: 2px solid #3295d1;
  cursor:pointer;
}
.right-item img {
  margin-right: 0.1vw;
  width: 20%;
}
.right-date {
  color: #a6bcdb;
  width: 30%;
  margin-left: 0.5vw;
  /*text-align: right;*/
}
.worktimetext-left {
    width: 4.5vw;
    height: 1.5vh;
    line-height: 1.5vh;
    border-right: 2px solid #8b9eb6;
    margin-right: 0.5vw;
    margin-top: 0.5vh;
}
.bottom {
  position: absolute;
  bottom: 3vh;
  left: 0.5%;
  width: 98%;
  height: 22.5vh;
  /* background: red; */
  /*border: 2px solid #0b274f;*/
  display: flex;
}
.bottom-head {
  width: 100%;
  height: 2.8vh;
  /* background: linear-gradient(to right, #017fd3, rgba(0, 0, 0, 0)); */
  color: #fff;
  font-size: 1.6vh;
  display: flex;
  align-items: center;
  padding-left: 1vw;
}
.worktime {
  width: 19%;
  margin-top: 0.5vh;
  margin-left: 0.7vw;
  background: url(../assets/bottombg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.monitor {
  width: 17%;
  margin-top: 0.5vh;
  margin-left: 0.7vw;
  background: url(../assets/bottombg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.pressure {
  width: 20%;
  margin-top: 0.5vh;
  margin-left: 0.7vw;
  background: url(../assets/bottombg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.grouting {
  width: 20%;
  margin-top: 0.5vh;
  margin-left: 0.7vw;
  background: url(../assets/bottombg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.monitor-content {
  width: 100%;
  height: 19vh;
  display: flex;
  flex-wrap: wrap;
}
.monitor-item {
  height: 27%;
  width: 45%;
  margin: 2%;
  font-size: 0.6vw;
  background: url("../assets/monitorbg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.monitordata-parameter {
  color: #cbd9ea;
  text-align: center;
  margin-top: 0.6vh;
}
.monitordata-name {
  color: #73849b;
  text-align: center;
}
.grouting-content {
  margin-top: 4vh;
  width: 100%;
  height: 12vh;
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.15vw;
}
.grouting-item {
  height: 17%;
  width: 48%;
  margin-right: 2%;
  font-size: 0.6vw;
  color: #bbc8d6;
  display: flex;
  align-items: center;
}
.grouting-nav {
  width: 8%;
  height: 0.5vh;
  background: #39a8eb;
  margin-left: 3px;
}
.grouting-def {
  width: 8%;
  height: 0.5vh;
  background: #073b5d;
  margin-left: 3px;
}
.mytables {
  width: 25%;
  height: 22vh;
  margin-top: 0.5vh;
  margin-left: 0.7vw;
  /* border-bottom: 2px solid #395372; */
  color: #fff;
  font-weight: 100;
  background: url(../assets/bottombg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.mytables table {
  width: 95%;
  margin-left: 2.5%;
  height: 92%;
  font-size: 1.5vh;
  margin-top: 1vh;
  border-collapse: collapse;
  border-width: thin;
  border-style: solid;
  border-color: #43638f;
}
.mytables table th {
  width: 3vw;
}
.mytables table tr {
  height: 5vh;
}
.mytables table tr:nth-child(1) {
  /* border: 1px solid #43638f; */
  /* background: #243b5b; */
  color: #8b9eb6;
}
.worktime-content {
  height: 19vh;
}
.worktime-content {
  height: 19vh;
  display: flex;
}
.worktime-left {
  width: 35%;
}
.workborder {
  background: url("../assets/wokborder.png");
  width: 2px;
  height: 70%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 7%;
  margin-left: 1%;
}
.worktime-right {
  margin: auto;
  font-size: 0.7vw;
  margin-left: 0.3vw;

}
.worktime-item {
  color: #8b9eb6;
  display: flex;
  margin: 1.5vh 0 1.5vh 0;
}
.workitem-right {
  width: 5.5vw;
  background: url("../assets/workright.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 2.5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #cbd9ea;
  font-family: pmzd;
  letter-spacing: 0.1vw;
  
}
</style>

